import React, { useState, ChangeEvent, useEffect } from "react";

interface FileAttachmentProps {
  label?: string;
  buttonLabel?: string;
  existingFile?: File;
  onFileSelection: (file: File) => void;
}

const FileAttachment: React.FC<FileAttachmentProps> = ({ existingFile, label, buttonLabel, onFileSelection }) => {
  const [file, setFile] = useState<File | null>(existingFile || null);
  const [url, setUrl] = useState<string | null>(existingFile ? URL.createObjectURL(existingFile) : null);
  useEffect(() => {
      setFile(existingFile||null);
      if(existingFile) setUrl(URL.createObjectURL(existingFile));
      


    // Clean up URL on unmount only
    return () => {
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [existingFile]);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0] || null;
    if (selectedFile) {
      setFile(selectedFile);
      onFileSelection(selectedFile);

      // Create and set a new object URL for the selected file
      const newUrl = URL.createObjectURL(selectedFile);
      setUrl(newUrl);
    }
  };

  const handleFileDelete = () => {
    setFile(null);
    setUrl(null);
  };

  return (
    <div className="">
      {!file ? (
        <div className="d-flex align-items-start">
          <input
            type="file"
            className="d-none"
            id="fileInput"
            onChange={handleFileChange}
          />
          <label htmlFor="fileInput" className="mt-7 btn btn-light-primary">
            <i className="fa fa-paperclip me-2" aria-hidden="true"></i>
            {buttonLabel ? buttonLabel : "Attach File".toTranslatedDisplay()}
          </label>
        </div>
      ) : (
        <div className="file-preview mt-3">
          {label && <label className="form-label mt-3">{label}</label>}
          <div className="d-flex align-items-center">
            <a
              href={url!}
              download={file.name.split('/').pop()} // Set the file name for download
              className="fw-bold text-decoration-none text-truncate d-inline-block"
              style={{ maxWidth: "150px", cursor: 'pointer' }}
            >
              {file.name.split('/').pop()}
            </a>
            <button
              type="button"
              className="ms-2 btn btn-light btn-sm"
              onClick={handleFileDelete}
            >
              <i className="fa fa-trash text-danger me-1" aria-hidden="true"></i>
            </button>
          </div>
          {file.type.startsWith("image/") && (
            <div className="file-image-preview mt-2">
              <img src={url!} alt="file preview" className="img-thumbnail" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FileAttachment;
